import { useEffect, useState } from "react";
import { FaPlus, FaTrashAlt } from "react-icons/fa";

const PreferredItemsTab = ({ preferredItems, onSave }) => {
  const [items, setItems] = useState(preferredItems);

  const handleAddItem = () => {
    setItems([...items, { name: "", category: "" }]);
  };

  const handleRemoveItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  useEffect(() => {
    onSave(items);
  }, [items, onSave]);

  return (
    <div>
      <h3 className="text-lg font-bold mb-2">Preferred Items</h3>
      {items.map((item, index) => (
        <div key={index} className="grid grid-cols-2 gap-4 mb-2">
          <input
            type="text"
            placeholder="Item Name"
            value={item.name}
            onChange={(e) =>
              setItems(
                items.map((itm, i) =>
                  i === index ? { ...itm, name: e.target.value } : itm
                )
              )
            }
            className="w-full border border-[#d8d8d8] p-2 rounded"
          />
          <input
            type="text"
            placeholder="Category"
            value={item.category}
            onChange={(e) =>
              setItems(
                items.map((itm, i) =>
                  i === index ? { ...itm, category: e.target.value } : itm
                )
              )
            }
            className="w-full border border-[#d8d8d8] p-2 rounded"
          />
          <button
            onClick={() => handleRemoveItem(index)}
            className="text-red-600 hover:underline"
          >
            <FaTrashAlt />
          </button>
        </div>
      ))}
      <button
        onClick={handleAddItem}
        className="px-4 py-2 rounded bg-[#c7eac9] text-[#191919] hover:bg-[#ebf8ec]"
      >
        <FaPlus /> Add Item
      </button>
    </div>
  );
};

export default PreferredItemsTab;
